import { css } from 'styled-components';
import token from 'styled-token';
import { BUTTON_TYPES } from '../../constants';
import { hoverMediaQueryMixin } from '../hoverMediaQueryMixin';

/** @class PropertyCardMenuPopperMixin */
/** @method */
export var PropertyCardMenuPopperMixin = function PropertyCardMenuPopperMixin(props) {
  return token({
    borderRadius: 'Button.borderRadius',
    defaultIconFill: 'PropertyCard.popperMenu.default.fill',
    focusShadow: 'PropertyCard.popperMenu.boxShadow.focus',
    hoverBackgroundColor: 'PropertyCard.default.popperMenu.backgroundColor.hover',
    iconColors: ["Button." + BUTTON_TYPES.primary + "Inverse"],
    iconSize: 'PropertyCard.popperMenu.iconSize',
    targetSize: 'accessibility.targetSize'
  }, function (_ref) {
    var borderRadius = _ref.borderRadius,
      _ref$defaultIconFill = _ref.defaultIconFill,
      defaultIconFill = _ref$defaultIconFill === void 0 ? 'transparent' : _ref$defaultIconFill,
      focusShadow = _ref.focusShadow,
      _ref$hoverBackgroundC = _ref.hoverBackgroundColor,
      hoverBackgroundColor = _ref$hoverBackgroundC === void 0 ? 'transparent' : _ref$hoverBackgroundC,
      iconColors = _ref.iconColors,
      iconSize = _ref.iconSize,
      targetSize = _ref.targetSize;
    return css(["border-radius:", "px;position:relative;", ";&:after{content:'';display:block;width:", "px;height:", "px;left:", "px;min-width:", "px;margin-top:-", "px;position:absolute;top:50%;}svg{height:", "px;margin-right:0;width:", "px;.MoreIcon__outline{fill:", ";}.MoreIcon__fill{fill:", ";}}&:hover{.MoreIcon__outline{fill:", ";}.MoreIcon__fill{fill:", ";}}&:active{.MoreIcon__outline{fill:", ";}.MoreIcon__fill{fill:", ";}}&:focus{box-shadow:", ";.MoreIcon__outline{fill:", ";}.MoreIcon__fill{fill:", ";}}&:focus-visible{outline:0;}"], borderRadius, hoverMediaQueryMixin("\n                background-color: " + hoverBackgroundColor + ";\n            "), targetSize, targetSize, (iconSize - targetSize) / 2, iconSize, targetSize / 2, iconSize, iconSize, iconColors.fontColor, defaultIconFill, iconColors.fontColorHover, iconColors.backgroundColorHover, iconColors.fontColorActive, iconColors.backgroundColorActive, focusShadow, iconColors.fontColorHover, iconColors.backgroundColorActive);
  })(props);
};